export const MAINTAINING_BALANCE = 1000;

const toNumber = (value) => Number(value);

export const buildRedemptionRequest = (data) => {
  const settlementDetails = {
    fundCode: data.fundCode,
    shares: Number(data.shares),
    uuid: data.uuid,
    investmentUid: data.investmentUid,
    surveyData: data.surveyData,

    // bank settlement
    accountName: data.accountName,
    bankName: data.bankName,
    bankAccountNumber: data.bankAccountNumber,
    savingsAccount: data.savingsAccount,
  };

  if (data.acceptFullRedemptionConversion) {
    settlementDetails.acceptFullRedemptionConversion = true;
  }

  return settlementDetails;
};

export const getRedemptionSurveyError = ({ reasons, otherReason }) => {
  if (!Array.isArray(reasons) || reasons.length === 0) {
    return "Select at least one reason for redeeming.";
  }

  if (
    reasons.includes("Other") &&
    (typeof otherReason !== "string" || !otherReason.trim())
  ) {
    return "Tell us why you are redeeming.";
  }

  return "";
};

export const getRedemptionSelection = (
  selectedShares,
  maxShares,
  currentRate
) => {
  const selected = toNumber(selectedShares);
  const maximum = toNumber(maxShares);
  const rate = toNumber(currentRate);

  if (
    !Number.isFinite(selected) ||
    !Number.isFinite(maximum) ||
    !Number.isFinite(rate)
  ) {
    return {
      shares: selectedShares,
      remainingValue: NaN,
      requiresFullRedemptionConversion: false,
    };
  }

  const remainingValue = (maximum - selected) * rate;
  const requiresFullRedemptionConversion =
    selected < maximum && remainingValue < MAINTAINING_BALANCE;

  return {
    shares: requiresFullRedemptionConversion ? maximum : selected,
    remainingValue,
    requiresFullRedemptionConversion,
  };
};

export const getFullRedemptionConfirmation = (error, fallbackRate) => {
  const response = error && error.response;
  const responseData = response && response.data;
  const data = responseData && (responseData.data || responseData);

  if (
    !response ||
    response.status !== 409 ||
    !responseData ||
    responseData.code !== "full-redemption-confirmation-required" ||
    !data ||
    data.redemptionType !== "full" ||
    !data.autoConverted ||
    !Number.isFinite(toNumber(data.effectiveShares))
  ) {
    return null;
  }

  const rate = Number.isFinite(toNumber(data.rate))
    ? toNumber(data.rate)
    : fallbackRate;

  return {
    effectiveShares: toNumber(data.effectiveShares),
    rate,
  };
};

export const getFullRedemptionConversionUiState = (
  requiresFullRedemptionConversion,
  hasAcceptedFullRedemptionConversion
) => ({
  controlsLocked: Boolean(requiresFullRedemptionConversion),
  acknowledgementRequired:
    Boolean(requiresFullRedemptionConversion) &&
    !hasAcceptedFullRedemptionConversion,
});

export const canSubmitRedemption = ({
  hasAcceptedTerms,
  requiresFullRedemptionConversion,
  hasAcceptedFullRedemptionConversion,
}) =>
  hasAcceptedTerms &&
  (!requiresFullRedemptionConversion || hasAcceptedFullRedemptionConversion);
